import {get, post} from "./action.service";
import axios, { AxiosRequestConfig } from 'axios';
import { Auth } from "aws-amplify";
import { defaultConfig } from './action.service';
import _ from "lodash";

export const getGeneralSettings = async() => {
    const user = await Auth.currentAuthenticatedUser();
    return axios.get('/GetDeviceShadow', _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }, {params: {
        shadowName: 'generalSettings'
    }})).then((res) => _.get(res.data.state.desired, 'GeneralSettings', _.get(res.data.state.reported, 'GeneralSettings', {})))
    // return get('/getGeneralSettings').then(
    //     (res) => _.get(res.data.state.desired, 'GeneralSettings', _.get(res.data.state.reported, 'GeneralSettings', {}))
    // )
}

export const updateGeneralSettings = async(data: any) => {
    const user = await Auth.currentAuthenticatedUser();
    return axios.post('/updateGeneralSettings',{
        data: data
    }, _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }))
    // return post('updateGeneralSettings', {
    //     'GeneralSettings': data
    // });
}